import { DateTime } from 'luxon';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { object, string } from 'yup';

import { useToast } from 'Component/Alerta';
import Botao from 'Component/Botao';
import BotaoLink from 'Component/BotaoLink';
import Form, { Assinatura, Botao as BotaoForm } from 'Component/Form';
import Imagem from 'Component/Imagem';
import RelogioDePonto from 'Interface/RelogiosDePonto';
import {
  useEditarRelogioDePontoMutation,
  useRecuperarRelogioDePontoQuery,
} from 'View/Service/Default/RelogiosDePonto';

const regras = object({
  assinatura: string().required('Obrigatório'),
});

const Assinar = (): React.ReactElement => {
  const { id = 0 } = useParams();
  const toast = useToast();
  const navegacao = useNavigate();

  const [editarRelogio] = useEditarRelogioDePontoMutation();

  const { data: { relogio_de_ponto } = {} } =
    useRecuperarRelogioDePontoQuery(id);

  const enviar = async (dados: RelogioDePonto): Promise<void> => {
    try {
      await editarRelogio({
        ...dados,
        assinatura: dados.assinatura,
        assinado: 1,
        data_da_assinatura: DateTime.now().toISO(),
      }).unwrap();

      navegacao('/relogios-de-ponto/historico');
    } catch (erro) {
      toast({
        tema: 'danger',
        titulo: 'Erro ao assinar',
        conteudo: 'Verifique os logs para mais informações',
      });
    }
  };

  return (
    <div className="container">
      <div className="row justify-content-center py-5">
        <div className="col-md-5">
          <h1 className="text-center">Assinar relógio de ponto</h1>
          <p>
            Faça sua assinatura no campo abaixo para assinar seu relógio de
            ponto.
          </p>
          <Form
            onSubmit={enviar}
            regras={regras}
            inicial={relogio_de_ponto}
            desabilitado={relogio_de_ponto?.assinado == 1}
          >
            {relogio_de_ponto?.assinado ? (
              <Imagem src={relogio_de_ponto.assinatura} className="img-fluid" />
            ) : (
              <Assinatura name="assinatura" rotulo="Assinatura" />
            )}
            <div className="text-center">
              <BotaoForm>Assinar</BotaoForm>{' '}
            </div>
          </Form>
          <div className="text-center mt-3">
            <BotaoLink to="/relogios-de-ponto/historico" tema="light">
              Cancelar
            </BotaoLink>{' '}
            <Botao
              icone="cloud-download-fill"
              tema="success"
              onClick={() => window.open(relogio_de_ponto?.url)}
            >Download</Botao>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Assinar;
